var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOpenStatusOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.286 13.03H1.714c.101.99.345 1.943.707 2.832l2.24-1.294a7.53 7.53 0 01-.375-1.537zm1.557-9.369A10.312 10.312 0 003.814 5.65l2.24 1.293A7.929 7.929 0 017.13 5.894L5.843 3.661zm7.37-1.946v2.578a7.776 7.776 0 016.518 7.667c0 4.285-3.48 7.77-7.76 7.77a7.728 7.728 0 01-2.866-.549l-1.288 2.233c1.27.56 2.676.872 4.15.872 5.694 0 10.31-4.621 10.31-10.321.009-5.283-3.956-9.635-9.065-10.25zm-2.484 2.578V1.715a10.24 10.24 0 00-2.731.72L9.29 4.672a7.9 7.9 0 011.44-.379zM2.543 7.781a10.362 10.362 0 00-.787 2.768H4.34a7.53 7.53 0 01.43-1.478L2.543 7.78zm3.313 8.961l-2.231 1.29c.58.8 1.275 1.512 2.058 2.118l1.292-2.24a8.393 8.393 0 01-1.12-1.168z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOpenStatusOutline);
export default __webpack_public_path__ + "76f8852c703e873f1315975793e64837.svg";
export { ForwardRef as ReactComponent };